import { render } from "./ChatItem.vue?vue&type=template&id=57a0facf&scoped=true"
import script from "./ChatItem.vue?vue&type=script&lang=js"
export * from "./ChatItem.vue?vue&type=script&lang=js"

import "./ChatItem.vue?vue&type=style&index=0&id=57a0facf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a0facf"]])

export default __exports__